import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { LoginForm } from '../components/organisms';
import { AuthTemplate } from '../components/templates';
import { useAuth } from '../lib/auth';

export function LoginPage() {
  const { username, signIn } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const redirectTo = (location.state as { from?: string } | null)?.from ?? '/';

  if (username) return <Navigate to={redirectTo} replace />;

  return (
    <AuthTemplate>
      <LoginForm
        onSubmit={async (identifier, password) => {
          await signIn(identifier, password);
          navigate(redirectTo, { replace: true });
        }}
      />
    </AuthTemplate>
  );
}
